export default __webpack_public_path__ + "static/media/bike_mov_1 (1).2c17ebac.mp4";